import { AwsConfig as AwsConstants } from '../Constants';

import BaseService, { RequestInterface } from '../Base';
import { ConfigGLOBAL } from '@interfaces/global/config-global';
import { ConfigEHSS } from '@interfaces/global/config-ehss';

export default class ConfigService extends BaseService {
    constructor() {
        super(AwsConstants.API_CONFIG, 'config');
    }
    async getGLOBAL(fields?: string[]): Promise<ConfigGLOBAL> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        try {
            const res = await super.get<ConfigGLOBAL>('global', params);
            return res;
        } catch (error) {
            return { userFields: [] };
        }
    }
    async updateGLOBAL(data: ConfigGLOBAL): Promise<ConfigGLOBAL> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<ConfigGLOBAL>('global', params);
        return res;
    }
    async getEHSS(fields?: string[]): Promise<ConfigEHSS> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<ConfigEHSS>('ehss', params);
        return res;
    }
    async updateEHSS(data: ConfigEHSS): Promise<ConfigEHSS> {
        const params: RequestInterface = {
            body: data
        };
        const res = await super.put<ConfigEHSS>('ehss', params);
        return res;
    }
}
